import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import isEmail from 'validator/lib/isEmail';
import getRecaptchaToken from '../helpers/getRecaptchaToken';

import '../styles/AccountVerificationConfirmationPage.css';
import AppContext from './context/AppContext';
import { bool } from 'prop-types';

const AccountVerificationConfirmationPage = ({ isMobile }) => {
    const { appContext } = useContext(AppContext);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isValidRequest, setIsValidRequest] = useState(true);
    const [isConfirming, setIsConfirming] = useState(true);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const email = searchParams.get('email');
    const code = searchParams.get('code');
    const handleVerificationRequest = useCallback(async () => {
        try {
            if (!email
                || !isEmail(email)
                || !code
                || !code.length) {
                setIsValidRequest(false);
                setIsConfirming(false);
                return;
            }
            setIsConfirming(true);
            setIsConfirmed(false);
            setErrorMessage(null);
            const response = await fetch(new URL('/api/user/verify/confirm', process.env.APP_URL), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    token: await getRecaptchaToken(appContext.config.recaptchaSiteKey),
                    email,
                    code,
                }),
            });
            const data = await response.json();
            setIsConfirming(false);
            if (!data.success) {
                if (data.error) {
                    setErrorMessage(data.error);
                }
                setIsConfirmed(false);
                return;
            }
            setIsConfirmed(true);
        } catch (e) {
            setIsConfirming(false);
            setErrorMessage(e.message);
        }
    }, [email, code]);
    useEffect(() => {
        handleVerificationRequest();
    }, [handleVerificationRequest]);
    useEffect(() => {
        const navigateTimeoutFunc = () => {
            navigate('/');
        };
        const navigateTimer = null;
        const NAVIGATE_TIMEOUT_MS = 3000;
        if (isConfirmed === true) {
            setTimeout(navigateTimeoutFunc, NAVIGATE_TIMEOUT_MS);
        }
        return () => {
            clearTimeout(navigateTimer);
        };
    }, [isConfirmed]);
    return (<Container
        fluid>
        <div
            className={'page--section mt-4'}>
            <h2>Verify Account</h2>
            {!isValidRequest && (<p>Invalid verification request.</p>)}
            {isConfirming === true && (<p>Confirming request...</p>)}
            {(isConfirming === false && isConfirmed === false) && (<p>Request failed.</p>)}
            {isConfirmed === true && (
                <p
                    style={{ color: 'green' }}>Your email has been verified successfully. Redirecting...</p>
            )}
            {(!isConfirming && errorMessage !== null) && (
                <p
                    style={{ color: 'red' }}>Error: {errorMessage ?? 'Failed.'}</p>
            )}
        </div>
    </Container>);
};

AccountVerificationConfirmationPage.propTypes = {
    isMobile: bool,
};

export default AccountVerificationConfirmationPage;